import { type SigninFormValues } from "./type";

export const defaultValuesSignInPage: SigninFormValues = {
  email: "",
  password: "",
  token: "",
};

export const buttonSigninTestId = "pages/signin/__components__/signin-forms/SigninForms/Button-signin";
